import styles from "./SiteFooter.module.css";

function SiteFooter() {
    return <div className={styles.wrapper}>Mallards are very cute</div>;
}

export default SiteFooter;
